import { IOutput, clone, EOutputScope } from '../../helpers/';
import types from '../types';

export interface IOutputDialogState {
    outputs: IOutput[];
    fromIndex: number;
    overIndex: number;
}

export const initialState: IOutputDialogState = {
    outputs: [],
    fromIndex: null,
    overIndex: null
};

const newOutput: IOutput = {
	Id: '',
	LogicalName: 'output',
	Name: 'Output',
	Type: 0,
    DisplayOnSummary: true,
    Group: null,
    Order: null,
    StaticName: 'Output',
    IsRequiredGlobalOutput: false,
    DisablePrepopulatedValue: false, 
    OutputScope: EOutputScope.Global
};

const outputDialogReducer = function(state: IOutputDialogState = initialState, action): IOutputDialogState {

	let stateClone: IOutputDialogState = clone(state);

	switch(action.type) {

		case types.ADD_GLOBAL_OUTPUT:
			stateClone = addOutput(stateClone, action.id);
			break;

        case types.UPDATE_GLOBAL_OUTPUT:
            stateClone = updateOutput(stateClone, action.output);
            break;

		case types.DELETE_GLOBAL_OUTPUT:
			stateClone = deleteOutput(stateClone, action.outputId);
			break;

		case types.SET_GLOBAL_OUTPUTS_STATE:
			stateClone = setOutputs(stateClone, action.outputs);
			break;
            
        case types.SET_MOVE_FROM_GLOBAL_OUTPUT:
            stateClone = setMoveFrom(stateClone, action.index);
            break;

        case types.SET_MOVE_OVER_GLOBAL_OUTPUT:
            stateClone = setMoveOver(stateClone, action.index);
            break;
            
        case types.MOVE_GLOBAL_OUTPUT:
            stateClone = move(stateClone, action.toIndex);
            break;

		default: 
			break;

	}

	return stateClone;

};

const addOutput = (state: IOutputDialogState, id: string): IOutputDialogState => {

	let output: IOutput = clone(newOutput);
    output.Id = id;
    output.OutputScope = EOutputScope.Global;

	state.outputs.push(output);
	return state;
};

const updateOutput = (state: IOutputDialogState, output: IOutput): IOutputDialogState => {

    let matches: any[] = state.outputs
		.map((o, i) => {
			return { output: o, index: i };
		})
		.filter(o => o.output.Id === output.Id);

    if (!matches.length)
        return state;

	state.outputs[matches[0].index] = output;

    return state;

};

const deleteOutput = (state: IOutputDialogState, outputId: string): IOutputDialogState => {

    state.outputs = state.outputs.filter(o => o.Id !== outputId);
    return state;

};

const setOutputs = (state: IOutputDialogState, outputs: IOutput[]): IOutputDialogState => {
	
	state.outputs = outputs;
	return state;

};

const setMoveFrom = (state: IOutputDialogState, fromIndex: number): IOutputDialogState => {

    state.fromIndex = fromIndex;
    return state;

};

const setMoveOver = (state: IOutputDialogState, index: number): IOutputDialogState => {

    state.overIndex = index;
    return state;

};

const move = (state: IOutputDialogState, toIndex: number): IOutputDialogState => {

    if (toIndex === null) {
        state.fromIndex = null;
        state.overIndex = null;
        return state;
    }

    let output: IOutput = clone(state.outputs[state.fromIndex]);

    state.outputs.splice(state.fromIndex, 1);
    state.outputs.splice(toIndex, 0, output);
    
    return state;

};

export default outputDialogReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/outputs-dialog.ts